// extracted by mini-css-extract-plugin
module.exports = {"bottomMenu":"BottomMenu_bottomMenu__bAK9u","menu":"BottomMenu_menu__uqJVO","link":"BottomMenu_link__4U8UO"};